import { render, staticRenderFns } from "./PublisherForm.vue?vue&type=template&id=15751950"
import script from "./PublisherForm.vue?vue&type=script&lang=js"
export * from "./PublisherForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports